import { memo, useRef, useState } from 'react';
import type { IMetadata } from '@moko/utils';
import OtherInfo from '../OtherInfo/OtherInfo';
import type { IOtherInfoProps } from '../OtherInfo/types';

export type FormPreviewMode = 'mobile' | 'desktop';

export interface FormPreviewProps {
  metadata: IMetadata;
  mode: FormPreviewMode;
  readOnly?: boolean;
  contained?: boolean;
  otherInfo?: Record<string, unknown>;
  onFetchUsers?: IOtherInfoProps['onFetchUsers'];
  onFetchAutoComplete?: IOtherInfoProps['onFetchAutoComplete'];
  orderComponentOptions?: IOtherInfoProps['orderComponentOptions'];
  orderComponentOptionsLoading?: IOtherInfoProps['orderComponentOptionsLoading'];
  orderComponentOptionsError?: IOtherInfoProps['orderComponentOptionsError'];
  orderComponentCatalog?: IOtherInfoProps['orderComponentCatalog'];
}

export const FormPreview = memo(function FormPreview({
  metadata,
  mode,
  readOnly,
  contained,
  otherInfo,
  onFetchUsers,
  onFetchAutoComplete,
  orderComponentOptions,
  orderComponentOptionsLoading,
  orderComponentOptionsError,
  orderComponentCatalog,
}: FormPreviewProps) {
  const [values, setValues] = useState<Record<string, unknown>>(
    () => otherInfo ?? {}
  );
  const isSaved = useRef(false);
  return (
    <div
      style={
        contained
          ? {
              height: '100%',
              minHeight: 0,
              minWidth: 0,
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
            }
          : undefined
      }
    >
      <OtherInfo
        metadata={metadata}
        otherInfo={JSON.stringify(values)}
        isSaved={isSaved}
        onOtherInfoChanged={(newValue: Record<string, unknown>) =>
          setValues(newValue)
        }
        hideTitle
        mode={mode}
        readOnly={readOnly}
        contained={contained}
        onFetchUsers={onFetchUsers}
        onFetchAutoComplete={onFetchAutoComplete}
        orderComponentOptions={orderComponentOptions}
        orderComponentOptionsLoading={orderComponentOptionsLoading}
        orderComponentOptionsError={orderComponentOptionsError}
        orderComponentCatalog={orderComponentCatalog}
      />
    </div>
  );
});
